import React, { useState } from 'react';
import { data } from './data';
import ZoomControls from './ZoomControls';
import TimelineItem from './TimelineItem';

const Timeline = () => {
  const [zoom, setZoom] = useState(1);

  return (
    <>
      <ZoomControls 
        onZoomIn={() => setZoom(z => Math.min(z + 0.2, 3))}
        onZoomOut={() => setZoom(z => Math.max(z - 0.2, 0.5))}
      />
      <div style={{ maxWidth: 600, margin: '0 auto', padding: 40, transform: `scale(${zoom})`, transformOrigin: 'top', transition: 'transform 0.3s' }}>
        <h1 style={{ textAlign: 'center', color: '#1976d2', marginBottom: 40 }}>EdTech Timeline</h1>
        {data.map(item => <TimelineItem key={item.id} {...item} />)}
      </div>
    </>
  );
};

export default Timeline;